// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import type { FormProps } from 'redux-form';

import type { Dispatch } from 'state/types';
import { bindActionCreatorsSafe } from 'util/safeDispatch';
import DialogPanel from 'view/App/DialogPanels/DialogPanel';
import localizedStrings from 'util/localizedStrings';
import { hideDialogPanel } from 'state/commands/dialogPanelCommands';
import { DELETE_VAULT_CATALOG_PANEL_ID } from 'util/constants';
import { getActivePanelData, getActivePanelId } from 'state/selectors';
import CheckRadio from 'view/Forms/BulmaCheckRadio';

type Props = {
  activePanelData: ?Object,
  activePanelId: ?string,
  confirm: boolean,
  intl: IntlShape,
  hideDialogPanel: typeof hideDialogPanel,
} & FormProps;

class DeleteVaultCatalogDialog extends Component<Props> {
  isOkEnabled: Function;
  submit: Function;

  constructor() {
    super();
    this.isOkEnabled = this.isOkEnabled.bind(this);
    this.submit = this.submit.bind(this);
  }

  submit(values) {
    const { activePanelData } = this.props;
    if (activePanelData && typeof activePanelData.doDelete === 'function') {
      activePanelData.doDelete();
    }
  }

  isOkEnabled() {
    return this.props.valid;
  }

  renderForm() {
    const {
      confirm,
      handleSubmit,
      intl: { formatMessage },
    } = this.props;
    return (
      <form
        className="portfolio-form-container"
        onSubmit={handleSubmit(this.submit)}
      >
        <div className="level">
          <div className="level-item">
            <div className="field">
              <div className="control">
                <Field
                  component={CheckRadio}
                  id="confirm"
                  label={formatMessage(localizedStrings.CATALOG_DELETE_CONFIRM)}
                  name="confirm"
                  type="checkbox"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          className={`notification ${
            confirm ? 'is-danger' : 'is-warning'
          } has-text-weight-bold has-text-centered`}
        >
          <FormattedMessage {...localizedStrings.DELETE_WARNING_BOX_MSG} />
          <br />
          <FormattedMessage
            {...localizedStrings.DELETE_WARNING_CATALOG_VAULT}
          />
        </div>
      </form>
    );
  }

  render() {
    const {
      activePanelId,
      handleSubmit,
      hideDialogPanel,
      intl: { formatMessage },
    } = this.props;

    return (
      <DialogPanel
        activePanelId={activePanelId}
        contentStyle={{ width: '650px', height: null }}
        customButtonText={formatMessage(localizedStrings.DELETE)}
        dialogFocusId="confirm"
        hideDialogPanel={hideDialogPanel}
        isOkEnabled={this.isOkEnabled}
        onSave={handleSubmit(this.submit)}
        panelId={DELETE_VAULT_CATALOG_PANEL_ID}
        panelTitle={formatMessage(localizedStrings.CATALOG_DELETE)}
        showCancel
      >
        {this.renderForm()}
      </DialogPanel>
    );
  }
}

function validate(data: Object, props: Props) {
  const errors = {};
  if (!data.confirm) {
    errors.confirm = 'Required';
  }

  return errors;
}

const form = reduxForm({
  form: DELETE_VAULT_CATALOG_PANEL_ID,
  validate,
})(injectIntl(DeleteVaultCatalogDialog));

const selector = formValueSelector(DELETE_VAULT_CATALOG_PANEL_ID);
export default connect(
  state => ({
    activePanelData: getActivePanelData(state),
    activePanelId: getActivePanelId(state),
    confirm: selector(state, 'confirm'),
  }),
  (dispatch: Dispatch) => bindActionCreatorsSafe({ hideDialogPanel })
)(form);



// WEBPACK FOOTER //
// ./src/view/Pages/CatalogsPage/DeleteVaultCatalogDialog.js